<template>
   <div>
       test
   </div>
</template>

<script>
export default {
   name: "ErrorPage",
   computed: {},
   data() {
       return {

       }
   },
   mounted() {

   },
   methods: {

   }
}
</script>
